export enum CashUpReviewEnum {
  TOTAL = 0,
  CASH = 1,
  CARD = 2
}